import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BuildInfo } from '@iot-platform/models/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BuildInfoService {
  private readonly httpClient: HttpClient = inject(HttpClient);

  getBuildInfo(): Observable<BuildInfo> {
    return this.httpClient.get<BuildInfo>('assets/data/build.json').pipe(map((data: BuildInfo) => data));
  }
}
